// src/components/AILoadingAnimation.js
import React, { useState, useEffect } from "react";
import "../styles/AILoadingAnimation.css";

const loadingMessages = [
  "Analyzing your resume...",
  "Identifying optimization opportunities...",
  "Enhancing content structure...",
  "Improving readability...",
  "Removing buzzwords...",
  "Optimizing white space...",
];

const completeMessages = [
  "Finalizing your resume...",
];

function AILoadingAnimation(props) {
  const isComplete = props.isComplete;
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const completionProgress = props.completionProgress;
  const setCompletionProgress = props.setCompletionProgress;
  const [dots, setDots] = useState("");

  useEffect(() => {
    // Message changes every 2 seconds
    const messageInterval = setInterval(() => {
      // Use different message arrays based on completion state
      const messagesArray = isComplete ? completeMessages : loadingMessages;
      setCurrentMessageIndex((prev) => (prev + 1) % messagesArray.length);
      // Reset progress when message changes
      setProgress(0);
    }, 2000);

    // Progress updates 10 times per message (every 200ms)
    // can we do 2 seperate intervals for the loading and completion phases? (0-90/0-100)
    // loading phase
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return 0;
        return prev + 10;
      });
    }, 200);

    // completion phase
    // once it hits 100 then move to next page
    const completionProgressInterval = setInterval(() => {
      setCompletionProgress((prev) => {
        if (!isComplete) return 0;
        //if (prev >= 100) return 100;
        return Math.floor(prev + 10, 0);
      });
    }, 200);

    const dotsInterval = setInterval(() => {
      setDots((prev) => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 300);

    return () => {
      clearInterval(messageInterval);
      clearInterval(progressInterval);
      clearInterval(completionProgressInterval);
      clearInterval(dotsInterval);
    };
  }, [isComplete]);

  return (
    <div className="ai-loading-container">
      <div className="ai-loading-box">
        {/* Content */}
        <div className="ai-content">
          {/* AI Icon */}
          <div className="ai-brain-container">
            <div className="ai-brain">
              <div className="ai-brain-inner"></div>
            </div>
            {/* Orbiting dots */}
            <div className="ai-orbit">
              <div className="ai-orbit-dot ai-dot-top"></div>
              <div className="ai-orbit-dot ai-dot-bottom"></div>
              <div className="ai-orbit-dot ai-dot-left"></div>
              <div className="ai-orbit-dot ai-dot-right"></div>
            </div>
          </div>

          {/* Loading text */}
          <div className="ai-loading-text">
            <h3>{isComplete ? "Resume optimization complete!" : "AI is optimizing your resume"}</h3>

            {/* Animated message */}
            <div className="ai-message">
              <p>
                {isComplete
                  ? completeMessages[currentMessageIndex % completeMessages.length]
                  : loadingMessages[currentMessageIndex % loadingMessages.length]}
                {dots}
              </p>
            </div>

            {/* Progress bar */}
            <div className="ai-progress-container">
              <div
                className="ai-progress-bar"
                style={{
                  width: `${isComplete ? completionProgress : progress}%`,
                }}
              ></div>
            </div>

            {/* Floating particles */}
            <div className="ai-particles">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="ai-particle"
                  style={{
                    left: `${15 + i * 12}%`,
                    animationDelay: `${i * 0.2}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AILoadingAnimation;